import {parseQueryString} from '@s-ui/js/lib/string'
import {Mushroom, Trackers} from '@adv-mt/mushroom'

import {createClientLogger, createServerLogger, initTracker} from '../../server/logger/index.js'
import {APP_NAMES} from '../config/index.js'
import {getExperimentationContext, setupOptimizelyAdapter} from './experimentationContext.js'
import getSuiContext from './suiContext.js'

const isTrackerInitializedIn = {
  [APP_NAMES.COCHES]: false,
  [APP_NAMES.MOTOS]: false
}

let initServerTracker = ({appName, site, req}) => {
  if (!isTrackerInitializedIn[site]) {
    initTracker({Reporter: Mushroom, appName, devMode: false})
    isTrackerInitializedIn[site] = true
  }

  const isInitializedInEverySite = Object.values(isTrackerInitializedIn).every(Boolean)
  // Ensure logger tracker is initialized just once.
  if (isInitializedInEverySite) initServerTracker = () => {}
}

export default async ({cookies, hydratedUserId, isClient, req, userAgent} = {}) => {
  // Extract search params from req.url (e.g., "/?e2e=true" -> "?e2e=true")
  const serverSearch = req?.url ? req.url.split('?')[1] || '' : ''
  const isE2eTest = Boolean(
    isClient ? parseQueryString(window.location.search)?.e2e : parseQueryString(serverSearch)?.e2e
  )

  if (!isE2eTest) await setupOptimizelyAdapter({isClient})

  const siteIdentifier = isClient ? process.env.TENANT : req.headers['x-serve-site'] || req.headers.host
  const isMotos = Boolean(siteIdentifier.match(/motos/))
  const search = isClient ? window.location.search : serverSearch
  const site = isMotos ? APP_NAMES.MOTOS : APP_NAMES.COCHES
  const appName = `${site}net`
  let logger

  if (isClient) {
    initTracker({
      Reporter: Mushroom,
      appName,
      devMode: false
    })
    logger = createClientLogger({Trackers})
  } else {
    initServerTracker({appName, site, req})
    logger = createServerLogger({Trackers, req})
  }

  const [suiContext, pdeContext] = await Promise.all([
    getSuiContext({cookies, isMotos, isClient, logger, req, userAgent}),
    getExperimentationContext({
      cookies,
      hydratedUserId,
      isClient,
      isMotos,
      req,
      search,
      userAgent
    })
  ])

  return {
    ...suiContext,
    ...pdeContext,
    site,
    isMotos,
    logger
  }
}
